export default __webpack_public_path__ + "static/why-repat-member-86a1227346aa8b45813b54f7ad320b66.webp";